<!-- <mat-toolbar fxLayout="row" fxLayoutAlign="start center" color="primary" class="mat-elevation-z8">
  <h1>
    Angular Monaco Editor library demo
  </h1>
</mat-toolbar> -->

<div fxLayout="column">
  <!-- <h2 class=" mat-headline">GEOJSON</h2> -->
  <mat-card fxLayout="row">
    <form fxFlex="100" [formGroup]="reactiveForm">
      <ngx-monaco-editor
        formControlName="code"
        [options]="mergeOptions({ language: 'json' })"
        ngDefaultControl
      >
      </ngx-monaco-editor>
      <div>
        <button class="btn" type="button" (click)="resetForm()">Reset</button>

        <button class="btn btn-primary" type="submit" (click)="onSubmit()">
          Submit
        </button>
      </div>
    </form>
  </mat-card>
</div>
